@import "../../../../../shared/styles/base";

.RadioCardContainer {
  .Hidden {
    height: 0;
    overflow: hidden;
  }

  .Options {
    .RadioCard {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      box-shadow: 0 0 0 1px inset $ds-neutral-200;
      border-radius: 0.5rem;
      transition: all 200ms;
      position: relative;

      + .RadioCard {
        margin-top: 1rem;
      }

      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 1.5rem;
        width: 1.5rem;
        right: 1.5rem;
        margin-bottom: 0.5rem;
      }

      & .Label {
        width: 100%;
        padding: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
      }

      .Title {
        font-weight: $ds-font-weight-medium;
        display: block;
        font-size: $ds-font-size-h4;
      }

      .Body {
        margin-top: 0.25rem;
      }

      &:hover {
        background: $ds-neutral-50;
      }

      &:has(input:checked) {
        background: $ds-violet-100;
        box-shadow: 0 0 0 2px inset $ds-violet-300;
      }
    }
  }
}
